<template>
    <div class="relative">
        <!-- Default Image -->
        <div v-if="isLoading" class="absolute inset-0 z-20 flex items-center justify-center bg-black bg-opacity-40">
            <div class="spinner rounded-full h-10 w-10 border-4 border-white border-t-transparent"></div>
        </div>
        <img
            v-if="!isLoadError"
            :src="getImageUrl(src)" 
            :alt="alt"
            class="absolute inset-0 w-full h-full" 
            :class="[
                roundedClass, 
                { 'cursor-pointer': previewable }, 
                { 'object-cover': !objectContain },
                { 'object-contain': objectContain },
            ]" 
            :style="{ opacity: isLoading ? 0 : 1 }"
            @load="handleThumbLoaded" 
            @error="handleThumbError"
            @click="handleClick"
        />

        <img
            v-if="isLoadError && !failedLoadAppLogo" 
            :src="currentSrc" 
            :alt="alt"
            class="absolute inset-0 w-full h-full object-contain bg-white" 
            :class="[roundedClass]" 
            :style="{ opacity: isLoading ? 0 : 1 }"
            @load="() => { isLoading = false}" 
            @error="() => { isLoading = false; failedLoadAppLogo = true; }"
        />

        <img
            v-if="failedLoadAppLogo && isLoadError" 
            :src="defaultImage" 
            :alt="alt"
            class="absolute inset-0 w-full h-full object-contain bg-white" 
            :class="[roundedClass]" 
            :style="{ opacity: isLoading ? 0 : 1 }"
            @load="() => { isLoading = false}" 
            @error="() => { isLoading = false}"
        />


        <!-- Modal Preview -->
        <div v-if="isModalOpen" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75"
            @click.self="closeModal" style="z-index: 100;">
            <div class="relative w-3/4 max-w-4xl">

                <!-- Loading Spinner Overlay -->
                <div v-if="isModalLoading" class="absolute inset-0 z-20 flex items-center justify-center bg-black bg-opacity-40">
                    <div class="spinner rounded-full h-10 w-10 border-4 border-white border-t-transparent"></div>
                </div>


                <img
                    :src="getImageUrl(original ?? src)" 
                    :alt="alt" 
                    class="w-full h-auto object-contain"
                    :style="{ opacity: isModalLoading ? 0 : 1 }"
                    @load="handleModalLoad"
                    @error="handleModalError"
                />
                <button @click="closeModal" class="absolute top-2 right-2 bg-white bg-opacity-30 text-black p-2 rounded-full">
                    <AppIcon icon="mdi:close" />
                </button>
            </div>
        </div>

    </div>
</template>

<script>
// import { mapGetters } from 'vuex';
import { MAINCONFIG } from '@/mainconfig';

export default {
    name: "LazyImage",
    props: {
        src: {
            type: String,
            required: true,
        },
        original: {
            type: String,
            default: null,
            required: false,
        },
        defaultImage: {
            type: String,
            // default: () => require('@/assets/images/400x300.webp'),
            default: () => '/assets/images/ch-placeholder-new.png',
        },
        alt: {
            type: String,
            default: "Image",
        },
        roundedClass: {
            type: String,
            default: "rounded", // Nilai default untuk border-radius
        },
        previewable: { type: Boolean, default: false }, // Default tidak bisa di klik
        objectContain: { type: Boolean, default: false }, // Default tidak bisa di klik
    },
    data() {
        return {
            isImageLoaded: false,
            currentSrc: this.src, // Default ke src awal
            isModalOpen: false, // State untuk modal
            isLoading: true,
            isModalLoading: false,
            isLoadError: false,
            isModalLoadError: false,
            failedLoadAppLogo: false,
            placeholder: '/assets/images/ch-placeholder-new.png'
        };
    },
    watch: {
        isModalOpen(newVal) {
            if (newVal === true) {
                this.isModalLoading = true;
            } 
        },
        // currentSrc(newVal) {
        //     this.currentSrc = newVal;
        //     this.isLoading = true;
        //     this.isLoadError = false;
        // },
    },
    computed: {
    },
    methods: {
        getImageUrl(filename) {
            try {
                return `${MAINCONFIG.BASE_URL}/images/${filename}`;
            } catch (e) {
                console.error("Error generating image URL:", e);
                return this.placeholder;
            }
        },
        handleClick() {
            if (this.currentSrc !== this.placeholder && this.previewable) {
                this.isModalOpen = true;
            }
        },
        closeModal() {
            this.isModalOpen = false;
        },
        handleModalLoad() {
            this.isModalLoading = false;
            this.isModalLoadError = false;
        },
        handleModalError() {
            this.isModalLoading = false;
            this.isModalLoadError = true;
        },
        handleThumbLoaded() {
            console.log('LOAD IMG SUCCESSS');
            this.isLoading = false;
            this.isLoadError = false;
        },
        handleThumbError() {
            console.log('LOAD IMG FAILED', this.currentSrc);
            this.isLoading = false;
            this.isLoadError = true;
            this.currentSrc = this.placeholder;
            console.log('LOAD IMG FAIL NEW', this.currentSrc, this.placeholder);
        }
    },
    mounted() {
        // console.log("src", this.src)
    },
    created() {
        const temp = localStorage.getItem('WEBSITE_LOGO');
        if (temp) {
          this.placeholder = `${MAINCONFIG.BASE_URL}/images/${temp}`;
        }
    }
};
</script>

<style scoped>
/* CSS untuk memastikan transisi opacity bekerja */
.transition-opacity {
    transition: opacity 0.5s ease-in-out;
}

.opacity-0 {
    opacity: 0;
}

.opacity-100 {
    opacity: 1;
}

.relative {
    position: relative;
}

.absolute {
    position: absolute;
}

.fixed {
    display: flex;
    align-items: center;
    justify-content: center;
}

.fixed img {
    max-height: 90vh;
}

.spinner {
  border: 4px solid white;
  border-top: 4px solid transparent;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
